import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import routes from './routes.js';

import { Router, hashHistory } from 'react-router'; 
import store, { history } from './store.js'
import "babel-polyfill";

import Raven from 'raven-js';

if(process.env.NODE_ENV === 'production') {
    Raven
        .config('https://8a255dd068a144bdb7552748e724a0c3@sentry.io/150538',{
            release: current_version,
            dataCallback: function(data) {
                let state = store.getState();

                data.extra.user = state.auth.user;
                data.extra.auth = state.auth.auth;
                data.extra.platform = state.general.platform;
                return data;
            }
        })
        .install();
}


ReactDOM.render(
	<Provider store={store}>
		<Router history={history} routes={routes} />
	</Provider>,window.document.getElementById("app")
);


// WEBPACK FOOTER //
// ./backend.js